<template>
  <div class="centerBox">
    <!-- 头部 -->
    <div class="BoxHead">
      <TabCheck
        :defaultActive="defaultActive"
        :tabs="tabs"
        :isRed="1"
        @tab-change="handleTabChange"
      />
    </div>
    <!-- 骨架屏区域 -->
    <div v-show="loading" class="skeleton-list">
      <div class="skeleton-item" v-for="(_, index) in 12" :key="index">
        <div class="skeleton-img"></div>
        <div class="skeleton-right">
          <div class="skeleton-row skeleton-header"></div>
          <div class="skeleton-row skeleton-tip"></div>
          <div class="skeleton-row skeleton-content"></div>
          <div class="skeleton-row skeleton-footer"></div>
        </div>
      </div>
    </div>
    <!-- 主体内容 -->
    <NoticeList
      v-show="!loading && total > 0"
      :arrList="arrList"
      @load-more="handleLoadMore"
      :isLoading="isLoading"
      :noMoreData="noMoreData"
      :isType="defaultActive"
    />
    <!-- 暂无消息 -->
    <div class="noneData" v-show="!loading && total == 0">
      <img
        class="noneIcon"
        :src="
          $utils.getPng(
            $store.state.theme == 'light'
              ? 'icon-gfans-none'
              : 'icon-gfans-none-dark'
          )
        "
      />
      <div class="font2">暂无消息</div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/utils/event-bus'
import { getMsgList } from '@/axios/notice'
import TabCheck from '@/components/TabCheck/index'
import NoticeList from '@/components/noticeList/index.vue'
export default {
  components: {
    TabCheck,
    NoticeList,
  },
  data() {
    return {
      // tabs: [
      //   { id: 4, name: '评论回复', count: 1 },
      //   { id: 3, name: '点赞/收藏/关注', count: 2 },
      //   { id: 2, name: '官方消息', count: 3 },
      //   { id: 1, name: '系统通知', count: 100 },
      // ], //切换tab数据
      defaultActive: 4,
      arrList: [], //数据列表
      loading: true, //页面是否在加载
      isLoading: false, //数据是否在加载
      noMoreData: false, //是不是没有更多数据了
      page: 1, //页码
      page_size: 30, //页数
      total: null, //总数
    }
  },
  computed: {
    tabs() {
      return this.$store.state.msgData
    },
  },
  created() {
    let noticeActive = localStorage.getItem('noticeActive')
    if (noticeActive) {
      this.defaultActive = noticeActive
    } else {
      this.defaultActive = 4
    }
    //初始化数据
    this.fetchData()
  },
  mounted() {
    // 监听头部一键已读事件
    eventBus.$on('clearNotice', () => {
      this.scrollToTop()
      this.loading = true
      this.isLoading = false
      this.noMoreData = false
      this.arrList = []
      this.page = 1
      this.fetchData()
    })
  },
  beforeDestroy() {
    eventBus.$off('clearNotice')
  },
  methods: {
    //初始化数据
    async fetchData() {
      if (this.isLoading || this.noMoreData) return

      this.isLoading = true
      try {
        let data = {
          msg_type: this.defaultActive,
          version_type: 2, //固定传2 用于区分 订阅号 和 gfans
          page: this.page,
          page_size: this.page_size,
        }
        let res = await getMsgList(data)
        if (res.status == 1) {
          this.arrList =
            this.page == 1
              ? [...res.data.list] // 首页直接赋值
              : [...this.arrList, ...res.data.list] // 后续页追加数据
          this.total = Number(res.data.total)
          this.noMoreData = this.arrList.length >= this.total
          this.page++
          this.loading = false
        }
      } catch {
        this.noMoreData = true
      } finally {
        this.isLoading = false
      }
    },
    //加载更多
    handleLoadMore() {
      this.fetchData()
    },
    //切换tab
    handleTabChange(row) {
      this.scrollToTop()
      this.loading = true
      this.isLoading = false
      this.noMoreData = false
      this.defaultActive = row
      localStorage.setItem('noticeActive', this.defaultActive)
      this.arrList = []
      this.page = 1
      this.fetchData()
    },
    // 回到顶部
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.centerBox {
  margin-top: -72px;
  width: 984px;
  .BoxHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 400;
    height: 72px;
    min-height: 72px;
    max-width: 984px;
    // width: 100%;
    width: 600px;
    padding-left: 2px;
    @include useTheme {
      background: getVar('bg-color');
    }
  }
  @media (max-width: 1100px) {
    .BoxHead {
      width: 400px;
      max-width: 100%;
    }
  }
  @media (max-width: 800px) {
    .BoxHead {
      width: 400px;
      max-width: 100%;
    }
  }
  @media (max-width: 600px) {
    .BoxHead {
      width: 410px;
      max-width: 101%;
    }
  }
  .noneData {
    width: 100% !important;
  }
  // 骨架屏样式
  .skeleton-list {
    width: 100%;
    border-radius: 16px 16px 0px 0px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
  }

  .skeleton-item {
    padding: 16px;
    display: flex;
    align-items: flex-start;
    @include useTheme {
      box-shadow: inset 0px -1px 0px 0px getVar('border-color2-f2f4f6');
    }
    .skeleton-img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 12px;
      animation: skeleton-pulse 1.5s infinite;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }

    .skeleton-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .skeleton-row {
      width: 100%;
      height: 16px;
      margin-bottom: 6px;
      border-radius: 4px;
      animation: skeleton-pulse 1.5s infinite;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }

    .skeleton-header {
      height: 22px;
      width: 60%;
      margin-bottom: 8px;
    }

    .skeleton-tip {
      width: 40%;
    }

    .skeleton-content {
      height: 36px;
      width: 100%;
    }

    .skeleton-footer {
      height: 20px;
      width: 30%;
      margin-top: 4px;
    }
  }
  // 骨架屏动画
  @keyframes skeleton-pulse {
    0%,
    100% {
      opacity: 0.6;
    }
    50% {
      opacity: 0.4;
    }
  }
}
</style>
